import { useMutation, useQuery } from "@tanstack/react-query";

import { api } from "./ApiClient";

import { CookiesHelper } from "../helpers/cookies.helper";

import { HMISaveV2Feedback } from "../types/services.interface";
import { EtyV2Feedback } from "../types/entities.interface";

export const useSaveV2Feedback = () => {
    const mutationFn = async (data: HMISaveV2Feedback): Promise<void> => {
        const token = CookiesHelper.get(`${process.env.REACT_APP__SESSION_TOKEN_NAME}`);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        await api.post('/v2_feedbacks/save', data.payload);
    };

    return useMutation({
        mutationFn,
        onMutate: (variables) => {
            variables.setIsProcessing(true);
        },
        onSuccess: (_, variables) => {
            variables.setIsSuccess(true);
        },
        onError: (error: any) => {
            window.alert(error?.response?.data?.message || 'Something went wrong.');
        },
        onSettled: (_, __, variables) => {
            variables.setIsProcessing(false);
        },
    });
};

export const useGetV2FeedbacksForCompleteData = (sessionId: string | null) => {
    const queryFn = async (): Promise<EtyV2Feedback[]> => {
        const res = await api.get(`/v2_feedbacks/complete-data/${sessionId}`);
        return res.data;
    };

    return useQuery({
        queryKey: ['v2-feedbacks-for-complete-data', sessionId],
        queryFn,
        retry: false,
        enabled: !!sessionId,
    });
};